const Detail = () => {
  return <div>hello world ffffffffffffffffff</div>;
};

export default Detail;
